export const menuEventsConfig = {
    parentSelector: '.header',
    events: {
        hamburger: {
            parentSelector: 'header-drawer > details.menu-drawer-container',
            selector: '.header__icon--menu svg.icon-hamburger',
            events: {
                open: {
                    event: 'menu',
                    component: '',
                    element: 'hamburger',
                    action: 'open',
                    trigger: 'click'
                },
                close: {
                    selector: '.header__icon--menu svg.icon-close',
                    event: 'menu',
                    component: '',
                    element: 'hamburger',
                    action: 'close',
                    trigger: 'click'
                }
            }
        },
        accordionToggle: {
            selector: 'details > summary.header__topmenu span, details > summary.menu-drawer__menu-item span',
            events: {
                open: {
                    event: 'menu',
                    component: '',
                    element: 'accordion',
                    action: 'open',
                    trigger: 'click',
                    getDynamicData: (element) => {
                        const fieldName = element.textContent.trim();
                        return {
                            field: fieldName
                        };
                    }
                },
                close: {
                    selector: 'summary.header__topmenu, summary.menu-drawer__menu-item',
                    event: 'menu',
                    component: '',
                    element: 'accordion',
                    action: 'close',
                    trigger: 'blur',
                    getDynamicData: (element) => {
                        const fieldName = element.textContent.trim();
                        return {
                            field: fieldName
                        };
                    }
                }
            }
        },
        mainMenuClick: {
            selector: 'nav.header__inline-menu > ul > li > a.header__menu-item.list-menu__item.link.link--text.focus-inset',
            event: {
                event: 'menu',
                component: 'main',
                element: 'link',
                action: 'click',
                trigger: 'focus',
                getDynamicData: (element) => {
                    return {
                        link_url: element.href,
                        link_text: element.textContent.trim()
                    };
                }
            }
        },
        subMenuClick: {
            selector: 'ul.header__submenu a.header__menu-item, .menu-drawer__submenu a.menu-drawer__menu-item',
            event: {
                event: 'menu',
                component: 'sub',
                element: 'link',
                action: 'click',
                trigger: 'focus',
                getDynamicData: (element) => {
                    return {
                        link_url: element.href,
                        link_text: element.textContent.trim()
                    };
                }
            }
        }
    }
}; 